import script from "./ShopExpress.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShopExpress.vue?vue&type=script&lang=ts&setup=true"

import "./ShopExpress.vue?vue&type=style&index=0&id=b93221c2&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b93221c2"]])

export default __exports__